(function () {
  // Idempotency guard: this file may be loaded by multiple sections on
  // the same page (e.g. a future template with both lp-collection and
  // lp-search), and Shopify's section-scoped {% javascript %} also
  // emits the same code if a section bundles it. Bail out if the IIFE
  // has already run.
  if (window.__lpcSliderBound) return;
  window.__lpcSliderBound = true;

  // ──────────────────────────────────────────────────────────────
  // bindPriceSlider — sync the 3 layers of the price filter:
  //   display inputs (UYU, what the user types)
  //   slider thumbs    (UYU, draggable)
  //   hidden inputs    (UYU, what gets serialized into the URL)
  // Parameterized on `scope` so the same logic works on both the
  // sidebar form AND the drawer clone. `applyer` is the callback
  // that commits the current state — applyAjax(root, form) for
  // the sidebar, a no-op for the drawer (user taps Apply instead).
  // ──────────────────────────────────────────────────────────────
  function bindPriceSlider(scope, applyer) {
    var priceSlider = scope.querySelector('[data-lpc-price-slider]');
    if (!priceSlider) return;
    var rangeMin = priceSlider.querySelector('[data-lpc-range-min]');
    var rangeMax = priceSlider.querySelector('[data-lpc-range-max]');
    var fill = priceSlider.querySelector('[data-lpc-price-fill]');
    var dispMin = scope.querySelector('[data-lpc-price-min-display]');
    var dispMax = scope.querySelector('[data-lpc-price-max-display]');
    var hiddenMin = scope.querySelector('[data-lpc-price-min-hidden]');
    var hiddenMax = scope.querySelector('[data-lpc-price-max-hidden]');
    if (!rangeMin || !rangeMax || !fill) return;

    // Read the absolute floor/ceiling from the data-* on the wrapper
    // (single source of truth, server-rendered with abs_min_disp=0 and
    // abs_max_disp). Fall back to the range input attrs for safety.
    var priceWrap = scope.querySelector('[data-lpc-price]');
    var absMinDisp = priceWrap ? parseFloat(priceWrap.getAttribute('data-lpc-price-floor')) : NaN;
    if (isNaN(absMinDisp)) absMinDisp = parseFloat(rangeMin.getAttribute('min'));
    if (isNaN(absMinDisp)) absMinDisp = 0;
    var absMaxDisp = priceWrap ? parseFloat(priceWrap.getAttribute('data-lpc-price-ceil')) : NaN;
    if (isNaN(absMaxDisp)) absMaxDisp = parseFloat(rangeMin.getAttribute('max'));
    if (isNaN(absMaxDisp) || absMaxDisp <= absMinDisp) absMaxDisp = absMinDisp + 1;

    // ── Techo persistente por coleccion ──────────────────────────
    // Shopify recalcula filter.range_max contra el resultado FILTRADO
    // (facetado): con un filtro de material activo, el techo del slider
    // se encogeria al maximo de ese subconjunto. Liquid no expone el
    // maximo de la coleccion completa, asi que guardamos el techo mas
    // alto visto en la sesion (el render sin filtros siempre reporta el
    // real) y lo usamos como techo de trabajo. sessionStorage = se
    // resetea al cerrar la pestana, asi cambios de precios no quedan
    // pegados entre visitas.
    var ceilKey = 'lpcPriceCeil:' + window.location.pathname;
    try {
      var storedCeil = parseFloat(sessionStorage.getItem(ceilKey));
      if (!isNaN(storedCeil) && storedCeil > absMaxDisp) {
        absMaxDisp = storedCeil;
      } else {
        sessionStorage.setItem(ceilKey, String(absMaxDisp));
      }
    } catch (e) { /* storage bloqueado — queda el techo facetado */ }

    // Propagar el techo de trabajo al DOM: attrs max de sliders e
    // inputs, placeholder del "HASTA" y el data-* (que lee el clon del
    // drawer al re-bindear).
    rangeMin.setAttribute('max', absMaxDisp);
    rangeMax.setAttribute('max', absMaxDisp);
    if (dispMin) dispMin.setAttribute('max', absMaxDisp);
    if (dispMax) {
      dispMax.setAttribute('max', absMaxDisp);
      dispMax.setAttribute('placeholder', absMaxDisp);
    }
    if (priceWrap) priceWrap.setAttribute('data-lpc-price-ceil', absMaxDisp);
    // Sin filtro de maximo activo, el server dejo el thumb en el techo
    // facetado (mas chico): subirlo al techo de trabajo para que lea
    // "sin tope".
    if (hiddenMax && hiddenMax.value === '') {
      rangeMax.value = absMaxDisp;
    }

    var rangeSpan = Math.max(1, absMaxDisp - absMinDisp);
    var rtl = false;
    try { rtl = getComputedStyle(scope).direction === 'rtl'; } catch (e) {}

    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

    function updateVisual(minV, maxV) {
      var leftPct = Math.max(0, Math.min(100, ((minV - absMinDisp) / rangeSpan) * 100));
      var rightPct = Math.max(0, Math.min(100, 100 - ((maxV - absMinDisp) / rangeSpan) * 100));
      if (rtl && 'insetInlineStart' in fill.style) {
        fill.style.insetInlineStart = leftPct + '%';
        fill.style.insetInlineEnd = rightPct + '%';
      } else {
        fill.style.left = leftPct + '%';
        fill.style.right = rightPct + '%';
      }
    }

    function syncFromSlider() {
      var minV = parseFloat(rangeMin.value);
      if (isNaN(minV)) minV = absMinDisp;
      var maxV = parseFloat(rangeMax.value);
      if (isNaN(maxV)) maxV = absMaxDisp;
      minV = clamp(minV, absMinDisp, absMaxDisp);
      maxV = clamp(maxV, absMinDisp, absMaxDisp);
      if (minV > maxV) { minV = maxV; rangeMin.value = minV; }
      updateVisual(minV, maxV);
      if (dispMin) dispMin.value = (minV === absMinDisp) ? '' : minV;
      if (dispMax) dispMax.value = (maxV === absMaxDisp) ? '' : maxV;
      if (hiddenMin) hiddenMin.value = (minV === absMinDisp) ? '' : minV;
      if (hiddenMax) hiddenMax.value = (maxV === absMaxDisp) ? '' : maxV;
    }

    function syncFromDisplay() {
      var rawMin = dispMin && dispMin.value;
      var rawMax = dispMax && dispMax.value;
      var minV = parseFloat(rawMin);
      if (isNaN(minV)) minV = absMinDisp;
      var maxV = parseFloat(rawMax);
      if (isNaN(maxV)) maxV = absMaxDisp;
      minV = clamp(minV, absMinDisp, absMaxDisp);
      maxV = clamp(maxV, absMinDisp, absMaxDisp);
      if (minV > maxV) { minV = maxV; }
      rangeMin.value = minV;
      rangeMax.value = maxV;
      var clearMin = (rawMin === '' || rawMin == null) || minV === absMinDisp;
      var clearMax = (rawMax === '' || rawMax == null) || maxV === absMaxDisp;
      if (hiddenMin) hiddenMin.value = clearMin ? '' : minV;
      if (hiddenMax) hiddenMax.value = clearMax ? '' : maxV;
      updateVisual(minV, maxV);
    }

    rangeMin.addEventListener('input', syncFromSlider);
    rangeMax.addEventListener('input', syncFromSlider);
    rangeMin.addEventListener('change', function (e) { e.stopPropagation(); syncFromSlider(); applyer(); });
    rangeMax.addEventListener('change', function (e) { e.stopPropagation(); syncFromSlider(); applyer(); });

    if (dispMin) {
      dispMin.addEventListener('input', syncFromDisplay);
      dispMin.addEventListener('change', function (e) { e.stopPropagation(); syncFromDisplay(); applyer(); });
      dispMin.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); syncFromDisplay(); applyer(); }
      });
    }
    if (dispMax) {
      dispMax.addEventListener('input', syncFromDisplay);
      dispMax.addEventListener('change', function (e) { e.stopPropagation(); syncFromDisplay(); applyer(); });
      dispMax.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); syncFromDisplay(); applyer(); }
      });
    }

    var initMin = parseFloat(rangeMin.value);
    if (isNaN(initMin)) initMin = absMinDisp;
    var initMax = parseFloat(rangeMax.value);
    if (isNaN(initMax)) initMax = absMaxDisp;
    updateVisual(initMin, initMax);
  }

  function captureFocus(root) {
    var active = document.activeElement;
    if (!active || !root.contains(active)) return null;
    if (active.id) return '#' + CSS.escape(active.id);
    var name = active.getAttribute && active.getAttribute('name');
    if (name) {
      if (active.type === 'checkbox' || active.type === 'radio') {
        return 'input[name="' + CSS.escape(name) + '"][value="' + CSS.escape(active.value) + '"]';
      }
      return '[name="' + CSS.escape(name) + '"]';
    }
    return null;
  }
  function restoreFocus(root, selector) {
    if (!selector) return;
    try {
      var el = root.querySelector(selector);
      if (el && typeof el.focus === 'function') el.focus({ preventScroll: true });
    } catch (e) { /* invalid selector — ignore */ }
  }

  function mergeFilterParams(targetUrl) {
    if (!targetUrl) return targetUrl;
    try {
      var preserved = new URLSearchParams(window.location.search);
      var keepKeys = [];
      preserved.forEach(function (_v, k) {
        if (k.indexOf('filter.') === 0 || k === 'sort_by') {
          if (keepKeys.indexOf(k) === -1) keepKeys.push(k);
        }
      });
      if (keepKeys.length === 0) return targetUrl;

      var target = new URL(targetUrl, window.location.origin);
      if (target.origin !== window.location.origin) return targetUrl;

      for (var i = 0; i < keepKeys.length; i++) {
        var key = keepKeys[i];
        if (target.searchParams.has(key)) continue;
        var values = preserved.getAll(key);
        for (var j = 0; j < values.length; j++) {
          target.searchParams.append(key, values[j]);
        }
      }
      return target.pathname + (target.search || '') + (target.hash || '');
    } catch (e) {
      return targetUrl;
    }
  }

  function applyAjax(root, formOrUrl) {
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId || !window.fetch || !window.DOMParser) {
      if (formOrUrl && typeof formOrUrl.submit === 'function') {
        formOrUrl.submit();
      } else if (typeof formOrUrl === 'string') {
        window.location.href = formOrUrl;
      }
      return;
    }

    var fullUrl;
    var isPopstate = (typeof formOrUrl === 'string') && (formOrUrl === window.location.href);
    if (typeof formOrUrl === 'string') {
      fullUrl = formOrUrl;
    } else {
      var form = formOrUrl;
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (typeof value === 'string' && value.trim() !== '') {
          params.append(key, value);
        }
      });
      var action = form.getAttribute('action') || window.location.pathname;
      var base;
      try {
        base = new URL(action, window.location.origin);
      } catch (e) {
        base = new URL(window.location.pathname, window.location.origin);
      }
      params.forEach(function (v, k) { base.searchParams.set(k, v); });
      fullUrl = base.pathname + (base.search || '');
    }

    var separator = fullUrl.indexOf('?') >= 0 ? '&' : '?';
    var ajaxUrl = fullUrl + separator + 'section_id=' + encodeURIComponent(sectionId);

    root._lpcReqId = (root._lpcReqId || 0) + 1;
    var myId = root._lpcReqId;

    if (root._lpcAbort && typeof root._lpcAbort.abort === 'function') {
      root._lpcAbort.abort();
    }
    if (root._lpcLoadMoreAbort && typeof root._lpcLoadMoreAbort.abort === 'function') {
      root._lpcLoadMoreAbort.abort();
      root._lpcLoadMoreAbort = null;
    }
    if (typeof AbortController !== 'undefined') {
      root._lpcAbort = new AbortController();
    } else {
      root._lpcAbort = null;
    }
    var fetchOpts = root._lpcAbort ? { signal: root._lpcAbort.signal } : {};

    root.setAttribute('data-lpc-loading', 'true');
    var grid = root.querySelector('[data-lpc-grid]');
    if (grid) grid.setAttribute('aria-busy', 'true');

    fetch(ajaxUrl, fetchOpts)
      .then(function (res) {
        if (myId !== root._lpcReqId) return null;
        if (!res.ok) throw new Error('Filter fetch failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        if (html == null) return;
        if (myId !== root._lpcReqId) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newLayout = doc.querySelector('.lp-col__layout');
        var currentLayout = root.querySelector('.lp-col__layout');

        if (!newLayout || !currentLayout) {
          window.location.href = fullUrl;
          return;
        }

        var focusSel = captureFocus(root);
        currentLayout.innerHTML = newLayout.innerHTML;

        // El hero (título + breadcrumb + eyebrow) vive FUERA de .lp-col__layout,
        // así que hay que actualizarlo aparte; si no, al navegar a una
        // subcategoría el título queda con el de la colección anterior
        // (ej. seguía diciendo "Indumentaria" estando en /collections/pantalones).
        var newHero = doc.querySelector('.lp-col__hero');
        var curHero = root.querySelector('.lp-col__hero');
        if (newHero && curHero) {
          curHero.innerHTML = newHero.innerHTML;
        }

        if (!isPopstate) {
          try {
            window.history.pushState({ lpc: true }, '', fullUrl);
          } catch (e) {}
        }

        bindLayoutContent(root);
        restoreFocus(currentLayout, focusSel);

        var liveRegion = root.querySelector('[data-lpc-live-count]');
        var newCountSrc = currentLayout.querySelector('[data-lpc-count-text]');
        if (liveRegion && newCountSrc) {
          var newText = newCountSrc.getAttribute('data-lpc-count-text');
          if (newText && liveRegion.textContent !== newText) {
            liveRegion.textContent = newText;
          }
        }

        var drawer = root.querySelector('[data-lpc-drawer]');
        var drawerBody = root.querySelector('[data-lpc-drawer-body]');
        if (drawer && !drawer.hidden && drawerBody && drawerBody.querySelector('form')) {
          var freshForm = root.querySelector('#lpc-facets-form');
          if (freshForm) {
            drawerBody.innerHTML = '';
            var clone = freshForm.cloneNode(true);
            clone.removeAttribute('id');
            drawerBody.appendChild(clone);
            bindPriceSlider(clone, function () {});
          }
        }

        root.removeAttribute('data-lpc-loading');
        if (grid) grid.removeAttribute('aria-busy');
      })
      .catch(function (err) {
        if (myId !== root._lpcReqId) return;
        if (err && err.name === 'AbortError') return;
        root.removeAttribute('data-lpc-loading');
        if (grid) grid.removeAttribute('aria-busy');
        window.location.href = fullUrl;
      });
  }

  function bindLayoutContent(root) {
    var facetsForm = root.querySelector('#lpc-facets-form');
    if (facetsForm) {
      bindPriceSlider(facetsForm, function () { applyAjax(root, facetsForm); });
    }

    var loadMoreBtn = root.querySelector('[data-lpc-loadmore]');
    var grid = root.querySelector('[data-lpc-grid]');
    var loadMoreWrap = root.querySelector('[data-lpc-loadmore-wrap]');

    if (loadMoreBtn && grid) {
      loadMoreBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (loadMoreBtn.classList.contains('lp-col__loadmore-btn--loading')) return;
        var url = loadMoreBtn.getAttribute('href');
        var sectionId = loadMoreBtn.getAttribute('data-section-id');
        if (!url || !sectionId) return;

        loadMoreBtn.classList.add('lp-col__loadmore-btn--loading');

        if (typeof AbortController !== 'undefined') {
          root._lpcLoadMoreAbort = new AbortController();
        }
        var lmOpts = root._lpcLoadMoreAbort ? { signal: root._lpcLoadMoreAbort.signal } : {};

        var separator = url.indexOf('?') >= 0 ? '&' : '?';
        fetch(url + separator + 'section_id=' + encodeURIComponent(sectionId), lmOpts)
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var currentGrid = root.querySelector('[data-lpc-grid]');
            if (currentGrid !== grid) return;

            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            doc.querySelectorAll('[data-lpc-cell]').forEach(function (cell) {
              grid.appendChild(cell);
            });
            var newBtn = doc.querySelector('[data-lpc-loadmore]');
            if (newBtn) {
              loadMoreBtn.setAttribute('href', newBtn.getAttribute('href'));
            } else if (loadMoreWrap) {
              loadMoreWrap.remove();
            }
            loadMoreBtn.classList.remove('lp-col__loadmore-btn--loading');
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            loadMoreBtn.classList.remove('lp-col__loadmore-btn--loading');
            window.location.href = url;
          });
      });
    }
  }

  function setupRootHandlers(root) {
    var drawer = root.querySelector('[data-lpc-drawer]');
    var drawerBody = root.querySelector('[data-lpc-drawer-body]');
    var drawerTitle = root.querySelector('[data-lpc-drawer-title]');
    var drawerReturnFocus = null;

    function openDrawer(kind) {
      if (!drawer || !drawerBody) return;
      drawerReturnFocus = document.activeElement;
      var facetsForm = root.querySelector('#lpc-facets-form');
      drawerBody.innerHTML = '';
      drawerBody.scrollTop = 0;
      if (kind === 'filters' && facetsForm) {
        var clone = facetsForm.cloneNode(true);
        clone.removeAttribute('id');
        drawerBody.appendChild(clone);
        if (drawerTitle && drawerTitle.dataset.titleFilters) {
          drawerTitle.textContent = drawerTitle.dataset.titleFilters;
        }
        bindPriceSlider(clone, function () {});
      } else if (kind === 'sort') {
        var sortSelect = root.querySelector('#lpc-sort-by');
        if (sortSelect) {
          if (drawerTitle && drawerTitle.dataset.titleSort) {
            drawerTitle.textContent = drawerTitle.dataset.titleSort;
          }
          var list = document.createElement('div');
          list.style.padding = '8px 0';
          Array.from(sortSelect.options).forEach(function (opt) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.textContent = opt.label;
            btn.style.cssText = 'display:flex;width:100%;padding:14px 4px;background:transparent;border:none;border-bottom:1px solid var(--lpc-ink-line, rgba(22, 32, 26,0.10));cursor:pointer;text-align:left;font-family:var(--lp-font-body);font-size:15px;color:var(--lpc-ink, #16201A);font-weight:' + (opt.selected ? '700' : '400');
            btn.addEventListener('click', function () {
              sortSelect.value = opt.value;
              var form = root.querySelector('#lpc-facets-form');
              if (form) applyAjax(root, form);
              closeDrawer();
            });
            list.appendChild(btn);
          });
          drawerBody.appendChild(list);
        }
      }
      drawer.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var firstFocusable = drawer.querySelector('[data-lpc-drawer-close]');
      if (firstFocusable) firstFocusable.focus();
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.hidden = true;
      document.documentElement.style.overflow = '';
      if (drawerReturnFocus && typeof drawerReturnFocus.focus === 'function') {
        try { drawerReturnFocus.focus(); } catch (e) {}
      }
    }

    root._lpcCloseDrawer = function () {
      if (drawer && !drawer.hidden) closeDrawer();
    };
    root._lpcDrawer = drawer;

    root.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-lpc-open-drawer]');
      if (openBtn) {
        openDrawer(openBtn.getAttribute('data-lpc-open-drawer'));
        return;
      }
      var applyBtn = e.target.closest('[data-lpc-drawer-apply]');
      if (applyBtn) {
        var drawerForm = drawerBody && drawerBody.querySelector('form');
        if (drawerForm) applyAjax(root, drawerForm);
        closeDrawer();
        return;
      }
      var drawerClearBtn = e.target.closest('.lp-col__drawer-clear');
      if (drawerClearBtn) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        applyAjax(root, drawerClearBtn.href);
        closeDrawer();
        return;
      }
      var closeBtn = e.target.closest('[data-lpc-drawer-close]');
      if (closeBtn) {
        closeDrawer();
        return;
      }

      // Chevron de subcategoría: despliega/colapsa las hijas. UI pura (no
      // navega), así que funciona también con el drawer abierto.
      var subcatToggle = e.target.closest('[data-lpc-subcat-toggle]');
      if (subcatToggle) {
        e.preventDefault();
        var stExpanded = subcatToggle.getAttribute('aria-expanded') === 'true';
        subcatToggle.setAttribute('aria-expanded', stExpanded ? 'false' : 'true');
        var stItem = subcatToggle.closest('.lp-col__subcat-item');
        var stSublist = stItem && stItem.querySelector('.lp-col__subcats-sublist');
        if (stSublist) {
          if (stExpanded) { stSublist.setAttribute('hidden', ''); }
          else { stSublist.removeAttribute('hidden'); }
        }
        return;
      }

      if (drawer && !drawer.hidden) return;

      var chipLink = e.target.closest('.lp-col__chip');
      if (chipLink) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        applyAjax(root, chipLink.href);
        return;
      }
      var subcatLink = e.target.closest('[data-lpc-subcat]');
      if (subcatLink) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        if (subcatLink.getAttribute('target') === '_blank') return;
        var subcatHref = subcatLink.getAttribute('href');
        if (!subcatHref) return;
        e.preventDefault();
        applyAjax(root, mergeFilterParams(subcatHref));
        return;
      }
      var clearLink = e.target.closest('.lp-col__filters-clear');
      if (clearLink) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        applyAjax(root, clearLink.href);
        return;
      }
      var emptyCta = e.target.closest('.lp-col__empty-cta');
      if (emptyCta) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        // Solo interceptar (AJAX) los CTA que apuntan a una colección (ej.
        // "Limpiar" → collection.url). Los que van a otra ruta — "Volver al
        // inicio" → / — deben navegar normal: el home no tiene esta sección,
        // así que un swap dejaría la página rota con la URL pisada en '/'.
        var ecHref = emptyCta.getAttribute('href') || '';
        if (ecHref.indexOf('/collections/') === -1) return;
        e.preventDefault();
        applyAjax(root, emptyCta.href);
        return;
      }
    });

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (drawer && !drawer.hidden) return;
      if (t.matches('input[type="number"]')) return;
      if (t.matches('input[type="range"]')) return;
      if (t.matches('input[type="hidden"]')) return;
      var form = root.querySelector('#lpc-facets-form');
      if (!form) return;
      var inForm = !!t.closest('#lpc-facets-form');
      var isSortSelect = t.id === 'lpc-sort-by';
      if (inForm || isSortSelect) {
        applyAjax(root, form);
      }
    });

    root.addEventListener('submit', function (e) {
      if (e.target && e.target.id === 'lpc-facets-form') {
        e.preventDefault();
        applyAjax(root, e.target);
      }
    });
  }

  // El header es sticky (top:0). El sidebar de filtros también es sticky, así
  // que su `top` debe quedar JUSTO debajo del header o el header lo tapa.
  // Medimos la altura real del header (varía con el ancho/wrap) y la
  // exponemos como --lpc-sidebar-sticky-top.
  function syncStickyTop() {
    var hdr = document.querySelector('.shopify-section-group-header-group')
      || document.querySelector('.section-header')
      || document.querySelector('.lp-header');
    if (!hdr) return;
    var h = Math.ceil(hdr.getBoundingClientRect().height);
    if (h <= 0) return;
    // OJO: el valor va en cada sección .lp-col, NO en <html>. La sección ya
    // define --lpc-sidebar-sticky-top inline (desde el setting), y por cercanía
    // en el árbol ese valor le gana al de <html> — si lo seteábamos en <html>
    // quedaba ignorado y el sidebar se metía debajo del header. Seteándolo en
    // la propia .lp-col sobreescribimos el inline y el sticky queda justo debajo.
    var val = (h + 16) + 'px';
    var cols = document.querySelectorAll('.lp-col');
    for (var i = 0; i < cols.length; i++) {
      cols[i].style.setProperty('--lpc-sidebar-sticky-top', val);
    }
  }

  function boot() {
    document.querySelectorAll('.lp-col').forEach(function (root) {
      if (root._lpcInit) return;
      root._lpcInit = true;
      setupRootHandlers(root);
      bindLayoutContent(root);
    });
    syncStickyTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var _lpcStickyRaf = 0;
  window.addEventListener('resize', function () {
    if (_lpcStickyRaf) return;
    _lpcStickyRaf = requestAnimationFrame(function () { _lpcStickyRaf = 0; syncStickyTop(); });
  });
  window.addEventListener('load', syncStickyTop);

  try {
    if (!history.state || !history.state.lpc) {
      history.replaceState({ lpc: 'initial' }, '');
    }
  } catch (e) {}

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.lp-col').forEach(function (root) {
      if (root._lpcCloseDrawer) root._lpcCloseDrawer();
    });
  });

  window.addEventListener('popstate', function (e) {
    if (!e.state || !e.state.lpc) return;
    document.querySelectorAll('.lp-col').forEach(function (root) {
      applyAjax(root, window.location.href);
    });
  });
})();
